import styled from 'styled-components';
import { Format, BaseStyledComponentProps, notchHeight, macTopBarHeight } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';
import UserAgentUtils from '../../utils/userAgent';

interface AppContainerProps {
	hasStatusBar: boolean;
	customCSS: string;
}

const statusBarHeight = (props: AppContainerProps) => props.hasStatusBar ? '20px' : 0;

const customCSS = (props: AppContainerProps) => props.customCSS || '';

UserAgentUtils.init();

const AppContainer = styled('div')`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding-top: ${statusBarHeight};
	background-color: ${(props: BaseStyledComponentProps) => props.theme.primary.backgroundColor};

	::before {
		content: '';
		position: absolute;
		width: 100%;
		height: ${statusBarHeight};
		top: 0;
		left: 0;
		background: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.topnavColor, props.theme.primary.topnavOpacity)};
	}

	${UserAgentUtils.isMacApp() && `
		padding-top: ${macTopBarHeight};

		::before {
			height: ${macTopBarHeight};
		}
	`}

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortraitNotch} {
			padding-top: ${notchHeight};

			::before {
				height: ${notchHeight};
			}
		}
	`}

	@media print {
		.svgSprites {
			display: none;
		}
	}

	${customCSS}
`;

const AppInnerContainer = styled('div')`
	position: relative;
	height: 100%;
`;

export { AppContainer, AppInnerContainer };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/styles.ts